import React from 'react';
import Slider from 'react-slick';
import { ImageDetail } from '../types';
import { useTranslation } from 'react-i18next';

interface ThumbnailSliderProps {
    images: ImageDetail[];
    onThumbnailClick: (index: number) => void;
}

export const ThumbnailSlider: React.FC<ThumbnailSliderProps> = ({
    images,
    onThumbnailClick
}) => {
    const { t } = useTranslation();

    const baseSliderSettings = {
        dots: false,
        infinite: images.length > 9,
        speed: 500,
        slidesToScroll: 1,
        focusOnSelect: true,
        swipeToSlide: true,
        arrows: images.length > 9,
    };

    const responsiveSettings = [
        { breakpoint: 1752, settings: { slidesToShow: Math.min(8, images.length) } },
        { breakpoint: 1552, settings: { slidesToShow: Math.min(7, images.length) } },
        { breakpoint: 1492, settings: { slidesToShow: Math.min(6, images.length) } },
        { breakpoint: 992, settings: { slidesToShow: Math.min(5, images.length) } },
        { breakpoint: 768, settings: { slidesToShow: Math.min(4, images.length) } },
        { breakpoint: 632, settings: { slidesToShow: Math.min(4, images.length) } },
        { breakpoint: 576, settings: { slidesToShow: Math.min(3, images.length) } },
        { breakpoint: 480, settings: { slidesToShow: Math.min(3, images.length) } }
    ];

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className='slider slider-nav limit-height mt-3 pt-3' style={{ padding: '1px' }}>
            <Slider
                {...baseSliderSettings}
                slidesToShow={Math.min(9, images.length)}
                responsive={responsiveSettings}
            >
                {images.map((img, index) => (
                    <div key={index} className="slick-slide p-1" style={{ outline: "none" }}>
                        <img
                            className="img-fluid border"
                            alt={`Thumbnail ${index + 1}`}
                            src={img.urlSmall ?? '/assets/images/no_image_small.jpg'}
                            style={{
                                height: "80px",
                                cursor: "pointer",
                                border: "1px solid #ddd",
                                objectFit: "cover"
                            }}
                            onClick={() => onThumbnailClick(index)}
                            loading="lazy"
                            onError={(e) => {
                                e.currentTarget.src = '/assets/images/no_image_small.jpg';
                                e.currentTarget.alt = t('gallery.thumbnailAltFallback', 'Miniatura non disponibile');
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};